import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useUser } from "../context/UserContext";
import Skeleton from "./Skeleton";
import Cookies from "universal-cookie";
const ProtectedRoute = ({ children }) => {
  const { userData, isLoading } = useUser();
  const location = useLocation();
  const cookies = new Cookies();
  const token = cookies.get("token");

  // Show loading state while user data is being fetched

  // Show loading state while checking authentication
  if (!userData) {
    return <Navigate to="/login" replace />;
  }
  if (Object.keys(userData).length === 0) {
    return <Skeleton />;
  }

  if (!token) {
    return <Skeleton />;
  }

  // Redirect to login if user is not authenticated

  // Check if user is trying to access vendor onboarding
  if (location.pathname === "/vendor-onboarding") {
    // If user is a vendor and has completed onboarding, redirect to dashboard
    if (
      userData.accountType === "VENDOR" &&
      userData.onboardingConfigured === true
    ) {
      return <Navigate to="/dashboard" replace />;
    }
    // If user is not a vendor, redirect to appropriate page
    if (userData.accountType !== "VENDOR") {
      return <Navigate to="/dashboard" replace />;
    }
  }

  // Generic enforcement: any protected route (this component only wraps protected ones)
  // If vendor has NOT completed onboarding, force them into onboarding except when already there
  const vendorPublicExempt = new Set([
    "/",
    "/vendors",
    "/homeowners",
    "/landlords",
    "/property-managers",
    "/short-term-rentals",
  ]);
  if (
    userData.accountType === "VENDOR" &&
    userData.onboardingConfigured !== true &&
    location.pathname !== "/vendor-onboarding" &&
    !vendorPublicExempt.has(location.pathname)
  ) {
    return <Navigate to="/vendor-onboarding" replace />;
  }

  // Render the protected component if user is authenticated and authorized
  return children;
};

export default ProtectedRoute;
